(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MessageDetailController', MessageDetailController);

    MessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Message', 'Conversation'];

    function MessageDetailController($scope, $rootScope, $stateParams, previousState, entity, Message, Conversation) {
        var vm = this;

        vm.message = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tikonApp:messageUpdate', function (event, result) {
            vm.message = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
